// -------------------------------
// CatMullRom winline animator
// -------------------------------
(function () {
  class GameWinlineCatMullRomAnimator {
    constructor() {
      this.WINLINE_ANIMATION_TIME = 1000;
      this.ended = false;
      this.winlineFinished = false;
      this.winlinesPlaying = false;
      this.fullWinAmount = 0;
      this.winlineContainer = undefined;

      this.winlines = [];
      this.winlinePool = [];
      this.winlinesCreated = 0;

      this.symbolWidth = 168;

      this.winlineWidth = this.symbolWidth * gameData.numReels;

      Reflex.registerEventHandler("ready", this.onLayoutComplete.bind(this));
      messageBus.subscribe(
        "spinner:WinningLinesEvent",
        this.doPayWins.bind(this)
      );
    }

    getWinline() {
      let movie = undefined;

      if (this.winlinePool.length > 0) {
        movie = this.winlinePool.pop();
      } else {
        movie = resourceManager.createObject(
          "movie",
          "Winline" + this.winlinesCreated,
          "slotContainer:winlineContainer",
          {
            definition: "winlineAnim",
          }
        );
        movie.loop = false;
        ++this.winlinesCreated;
      }
      return movie;
    }

    cleanUp() {
      for (let i = 0; i < this.winlines.length; ++i) {
        this.winlines[i].winline.visible = false;
        this.winlines[i].winline.gotoAndStop(0);
        this.winlinePool.push(this.winlines[i].winline);
      }
      this.winlines = [];
    }

    begin() {
      this.ended = false;
    }

    end() {
      this.ended = true;
    }

    playAnimations(sequence, symbols, slotMachine, callback) {
      this.winAmount = sequence[0].winAmount;
      this.callback = callback;
      this.winlineFinished = false;
      this.currentWinlineAnimations = [];

      this._completeCb = callback;
      this.symbols = symbols;
      this.slotMachine = slotMachine;

      for (let i = 0; i < symbols.length; ++i) {
        let cell = symbols[i].cell;
        let symPos = slotMachine.getSymbolPosition(cell.reel, cell.row, false);

        let winline = this.getWinline();

        winline.visible = true;

        winline.anchor.set(0.5);

        winline.position.set(symPos.x, symPos.y);

        this.winlines.push({
          winline: winline,
          posX: symPos.x,
          posY: symPos.y,
        });

        winline.gotoAndPlay(0);
      }
    }

    skipAnimation() {
      if (this.currentWinlineAnimations !== undefined) {
        this.winlinesPlaying = false;
        this.animationTime = this.totalAnimationTime;

        this.currentWinlineAnimations.forEach(function (animData) {
          animData.particles.particleEmitter.emit = false;
          animData.particles.visible = false;
        });
      }

      this.cleanUp();
    }

    onGameConfigEvent(gameConfigTask) {
      this.numReels = gameConfigTask.data.slotConfig.startingSymbols.length;
      this.numRows =
        gameConfigTask.data.slotConfig.startingSymbols[0].symbols.length;
      this.numWinlines = gameConfigTask.data.slotConfig.defaultNumLines;

      this.spots = [];
      let winlines = gameConfigTask.data.slotConfig.paylines;
      for (let i = 0; i < winlines.length; i++) {
        this.spots.push(winlines[i].spots);
      }
    }

    onOrientationChange() {
      this.winlines.forEach((winline) => {
        winline.winline.position.set(winline.posX, winline.posY);
      });
    }

    onStakeChanged(stake) {
      this.stake = stake;
    }

    clearWinlines() {
      this.cleanUp();
    }

    onLayoutComplete() {
      this.winlineContainer = resourceManager.get(
        "slotContainer:winlineContainer"
      );
      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "stake:stakeChanged",
        this.onStakeChanged.bind(this)
      );

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    doPayWins(task) {
      this.fullWinAmount = task.data.totalLineWinnings;
    }
  }

  let create = function () {
    return new GameWinlineCatMullRomAnimator();
  };
  resourceManager.registerSharedPlugin(
    "GameWinlineCatMullRomAnimatorEx",
    create
  );
})();
